import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TechnicalserviceService } from '../../services/technicalservice.service';
import { TechnicalserviceCompanyService } from '../../../configuration/services/technicalservice-company.service';
import htmlDocx from 'html-docx-js/dist/html-docx';
import * as FileSaver from 'file-saver';
import * as JsBarcode from 'jsbarcode';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';

declare var JSZip: any;
declare var Docxtemplater: any;
declare var JSZipUtils: any;
declare var ImageModule: any;
declare var fs: any;
declare var Buffer: any;

@Component({
  selector: 'app-view-technicalservice',
  templateUrl: './view-technicalservice.component.html',
  styleUrls: ['./view-technicalservice.component.css'],
  providers:[TechnicalserviceService,TechnicalserviceCompanyService]
})
export class ViewTechnicalserviceComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  person: any = {};
  technicalservice: any = {};
  technicalserviceCompanies: any = [];
  technicalServiceStatuses:any = [
    'Sin asignar',
    'Sin revisar',
    'Presupuesto aceptado',
    'Pte. de colocar piezas',
    'En proceso',
    'Pte. de aceptar presupuesto',
    'Pte. de llegada de piezas',
    'Finalizado',
    'Pte. de entregar a más con berto',
    'Pte. de recoger por el cliente',
    'Retirado por el cliente'
  ];
  enter_by_options:any = [
    {name:"Nueva entrada"},
    {name:"Garantía de compra"},
    {name:"Garantía de reparación"}
  ];
  config: any = {'sourceField': ['name']};
  role:number = 3;

  constructor(private technicalserviceService: TechnicalserviceService, private technicalserviceCompanyService:TechnicalserviceCompanyService,
              private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getTechnicalserviceCompanies();
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getTechnicalservice();
      }else{
        this.technicalservice.date = this.getDate(new Date());
      }
    });
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }
 
  change_name_input_guarantee(guarantee){
    let valor: string;
    if(guarantee==true){
      valor= "Si";
    }
    else{ 
      valor="No";

    }
   return valor;
  }

  getDeliveredAccessories(charger,cable,battery,mobileCase){
    let accessories ="";
    if (charger==true ){
      accessories+="Cargador,";
    }
    if(cable==true){
       accessories+="Cable,";
    }
     if(battery==true){
       accessories+="Batería,";
    }
    if(mobileCase==true){
       accessories+="Funda,";
    }
    if(accessories===""){
      accessories='No entrega ningún accesorio,';
    }
    accessories=accessories.substring(0,accessories.length-1);
    return accessories;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getTechnicalserviceCompanies(){
    this.technicalserviceCompanyService.query({}).subscribe((technicalserviceCompanies)=>{
      this.technicalserviceCompanies = technicalserviceCompanies;
    });
  }

  handlePersonSelected($event){
    if ($event.id != undefined){
      this.technicalservice.person = $event;
      //TODO maybe this line will be remove
      this.person = $event;
      this.technicalservice.nameAndSurname = this.person.name +" "+ this.person.surname;
      //Copy fields from person to entity
      this.copyPersonData(this.person, this.technicalservice);
    }
  }
  enterBySelected(e){
    this.technicalservice.enter_by = e.name
  }

  copyPersonData(person, entity){
    entity['nif'] = person.nif;
    entity['name'] = person.name;
    entity['surname'] = person.surname;
    entity['address'] = person.address;
    entity['cp'] = person.cp;
    entity['town'] = person.town;
    entity['state'] = person.state;
    entity['born_date'] = person.born_date;
  }

  getTechnicalservice(){
    this.technicalserviceService.get(this.id).subscribe((technicalservice) => {
      technicalservice.date = this.getDate(technicalservice.date);
      technicalservice.delivery_date_tsc = this.getDate(technicalservice.delivery_date_tsc);
      technicalservice.repair_date = this.getDate(technicalservice.repair_date);
      technicalservice.purchase_date = this.getDate(technicalservice.purchase_date);
      technicalservice.naturalCreatedAt = moment(technicalservice.createdAt).format("DD-MM-YYYY HH:mm");
      this.technicalservice = technicalservice;
      this.person = technicalservice.person;
      this.technicalservice.nameAndSurname = this.technicalservice.name +" "+ this.technicalservice.surname;
       this.technicalservice.createdByNameAndSurname = this.technicalservice.createdBy.name +" "+ this.technicalservice.createdBy.surname;
      if (this.technicalservice.technicalserviceCompany){
        this.technicalservice.technicalserviceCompany = this.technicalservice.technicalserviceCompany.id;
      }
      if (this.technicalservice.number){
        setTimeout( ()=>{
          JsBarcode("#barcode",this.technicalservice.number,{format: "ean13"});
          this.technicalservice.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
        },0)
      }
     
    });
  }

  saveTechnicalservice(){
    if (this.technicalservice.pin){
      if (!this.technicalservice.imei || this.technicalservice.imei.length === 15){
        if (this.technicalservice.id == undefined){
          this.generateBarcodeNumber(this.technicalservice.nif,this.technicalservice.person.id).then((barcode)=>{
            this.technicalservice.number = barcode;
            this.technicalserviceService.create(this.returnTechnicalserviceProperties(this.technicalservice))
            .subscribe((technicalservice) => {
              this.technicalserviceService.get(technicalservice.id).subscribe((technicalservice) => {
                technicalservice.date = this.getDate(technicalservice.date);
                technicalservice.delivery_date_tsc = this.getDate(technicalservice.delivery_date_tsc);
                technicalservice.repair_date = this.getDate(technicalservice.repair_date);
                technicalservice.purchase_date = this.getDate(technicalservice.purchase_date);
                this.technicalservice = technicalservice;
                this.router.navigate(['/technicalservice/list']);
              });
            });
          });
        }else{
          this.technicalserviceService.update(this.returnTechnicalserviceProperties(this.technicalservice))
          .subscribe((technicalservice) => {
            technicalservice.date = this.getDate(technicalservice.date);
            technicalservice.delivery_date_tsc = this.getDate(technicalservice.delivery_date_tsc);
            technicalservice.repair_date = this.getDate(technicalservice.repair_date);
            technicalservice.purchase_date = this.getDate(technicalservice.purchase_date);
            this.technicalservice = technicalservice;
            this.router.navigate(['/technicalservice/list']);
          });
        }
      }else{
      alert("El imei debe contener 15 dígitos");
      }
    }else{
      alert("Debes introducir el pin");
    }
  }

  calculateTechnicalServiceStatus(){
    if (this.technicalservice.withdrawal_date){
      return this.technicalServiceStatuses[10];
    }else if (this.technicalservice.budgeted){
      return this.technicalServiceStatuses[5];
    }else if (this.technicalservice.technicalserviceCompany){
      return this.technicalServiceStatuses[1];
    }else{
      return this.technicalServiceStatuses[0];
    }
  }

  calculateTechnicalServiceOrder(status){
    return _.findIndex(this.technicalServiceStatuses,(s)=>{return s == status});
  }

  returnTechnicalserviceProperties(technicalservice){
    var properties = {
      date: technicalservice.date,
      delivery_date_tsc: technicalservice.delivery_date_tsc,
      repair_date: technicalservice.repair_date,
      number: technicalservice.number,
      product: technicalservice.product,
      enter_by: technicalservice.enter_by,
      serial_number: technicalservice.serial_number,
      imei: technicalservice.imei,
      imei2: technicalservice.imei2,
      purchase_date: technicalservice.purchase_date,
      guarantee: technicalservice.guarantee,
      problems: technicalservice.problems,
      charger: technicalservice.charger,
      cable: technicalservice.cable,
      battery: technicalservice.battery,
      case: technicalservice.case,
      other_component: technicalservice.other_component,
      technicalserviceCompany: technicalservice.technicalserviceCompany,
      part:technicalservice.part?technicalservice.part:"",
      internal:technicalservice.internal,
      pin:technicalservice.pin,
      status: this.calculateTechnicalServiceStatus(),
      status_order: this.calculateTechnicalServiceOrder(this.calculateTechnicalServiceStatus())
    }
    if (technicalservice.id){
      properties['id'] = technicalservice.id;
    }else{
      properties['person'] = technicalservice.person.id;
      properties['nif'] = technicalservice.nif;
      properties['name'] = technicalservice.name;
      properties['surname'] = technicalservice.surname;
      properties['address'] = technicalservice.address;
      properties['cp'] = technicalservice.cp;
      properties['town'] = technicalservice.town;
      properties['state'] = technicalservice.state;
      properties['born_date'] = technicalservice.born_date;
    }
    return properties;
  }
 
  

  getDate(date){
    if (date){
      date = new Date(date);
      let month = (date.getMonth()+1) < 10? '0'+(date.getMonth()+1):(date.getMonth()+1);
      let day = date.getDate() < 10? '0'+date.getDate():date.getDate();
      return date.getFullYear() + "-" + month + '-' + day;
    }else{
      return null;
    }
  }
  generateBarcodeNumber(nif, id){
    return new Promise((resolve, reject) => {
      let barcode = '4';
      let params = {
        where: {nif:nif},
        sort: 'id ASC'
      };
      id = id.toString();
      for (let i=id.length; i<6; i++){
        id = '0'+id;
      }
      this.technicalserviceService.query(params).subscribe((technicalservices) => {
        let technicalservicesCount = '0';
        if (technicalservices.length > 0){
          let barcode = technicalservices[technicalservices.length -1].number;
          technicalservicesCount = (parseInt(barcode.substr(barcode.length - 5)) + 1).toString();
        }
        for (let i=technicalservicesCount.length; i<5; i++){
          technicalservicesCount = '0'+technicalservicesCount;
        }
        resolve(barcode + id + technicalservicesCount);
      });
    });
  }
 

  markAsPrinted(){
    var technicalservice= {
      id: this.technicalservice.id,
      printed: true
    }
    this.technicalserviceService.update(technicalservice)
      .subscribe((technicalservice) => {
        this.technicalservice();
      });
  }

  loadFile(url,callback){
    JSZipUtils.getBinaryContent(url,callback);
  }
    
 base64DataURLToArrayBuffer(dataURL) {
    const string_base64 = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    var binary_string;
    binary_string = new Buffer(string_base64, 'base64').toString('binary');
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      var ascii = binary_string.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes.buffer;
  };
   
  getDateForFooter(date){
    let dateObj=moment(date);
    let month=dateObj.lang("es").format('MMMM');
    let hour = dateObj.format('HH:mm');
    let day = dateObj.format('DD');
    let year = dateObj.format('YYYY');
    let dateResult = day+ " de " + month + " de " + year+',' +  " a las "+ hour + " horas. ";
    return dateResult;  
  }

   
  download(){

    var opts = {
      centered : false,
      // getImage :function(tagValue, tagName) {
      //   try {
      //     var fileContents = fs.readFileSync(tagValue);
      //   } catch (err) {
      //     console.log(err);
      //     // Here you get the error when the file was not found,
      //     // but you also get any other error
      //   }
      //   console.log(fs.readFileSync(tagValue))
      //   return fs.readFileSync(tagValue);
      // },
      getImage: function(image){
        return image;
      },
    
      getSize: function(img,tagValue, tagName) {
        return [150,150];
      }

    }
    var imageModule=new ImageModule(opts);
    var _this = this;
  ;
    this.loadFile("assets/tecnicalservice_template.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)   
      doc.setData({
      imageCB:_this.base64DataURLToArrayBuffer(_this.technicalservice.barcode_img.substring(0,_this.technicalservice.barcode_img.length-1)),
      number:_this.technicalservice.id,
      newdate:_this.getDateForFooter(_this.technicalservice.createdAt),
      technicalservice: [ 
            {
            first_name: _this.technicalservice.person.name != undefined? _this.technicalservice.person.name+' '+_this.technicalservice.person.surname: '',
            NIF:_this.technicalservice.person.nif,
            address:_this.technicalservice.person.address,
            town:_this.technicalservice.person.town,
            telephone1:_this.technicalservice.person.telephone,
            telephone2:_this.technicalservice.person.mobile != undefined? _this.technicalservice.person.mobile: '',
            purchase_date:_this.technicalservice.purchase_date?moment(_this.technicalservice.purchase_date).format("DD-MM-YYYY"):'',
            guarantee:_this.change_name_input_guarantee(_this.technicalservice.guarantee),
            description:_this.technicalservice.problems != undefined? _this.technicalservice.problems: '',
            email:_this.technicalservice.person.email != undefined? _this.technicalservice.person.email: '',
            article:_this.technicalservice.product != undefined? _this.technicalservice.product: '',
            accessories:_this.getDeliveredAccessories(_this.technicalservice.charger,_this.technicalservice.cable,_this.technicalservice.battery,_this.technicalservice.case),
            entry:_this.technicalservice.enter_by  != undefined? _this.technicalservice.enter_by: '',
            address_shop:_this.technicalservice.shop.address != undefined? _this.technicalservice.shop.address: '',
            telephone_shop:_this.technicalservice.shop.telephone != undefined? _this.technicalservice.shop.telephone: '',
            attended:_this.technicalservice.createdByNameAndSurname != undefined? _this.technicalservice.createdByNameAndSurname: '',
            
            
            } 
                      ]
          });
          
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      FileSaver.saveAs(out, 'Servicio Técnico.docx'); 
      _this.markAsPrinted();     
  })

}
}



// WEBPACK FOOTER //
// ./src/app/technicalservice/components/view-technicalservice/view-technicalservice.component.ts